import React, { useCallback } from 'react'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { Button, BUTTON_THEME } from '@st-operations/uikit/src/v2'

import './styles.scss'

export function ConfirmPrompt(props) {
  const {
    isOpen,
    title,
    description,
    okText,
    cancelText,
    onOK = () => {},
    onCancel = () => {},
    onIsOpenChange = () => {},
  } = props

  const handleOK = useCallback(() => {
    onIsOpenChange(false)
    onOK()
  }, [onOK, onIsOpenChange])

  const handleCancel = useCallback(async () => {
    onIsOpenChange(false)
    onCancel()
  }, [onCancel, onIsOpenChange])

  return (
    <Dialog open={isOpen}>
      <div className="confirm-prompt__container">
        <h3>{title}</h3>
        <span>{description}</span>
        <div>
          <Button theme={BUTTON_THEME.GHOST} onClick={handleCancel}>
            {cancelText}
          </Button>
          <Button onClick={handleOK}>{okText}</Button>
        </div>
      </div>
    </Dialog>
  )
}
